// import React from 'react';
// import styles from './QuarterlyTable.module.css';

// const QuarterlyTable = ({
//   data,
//   categories,
//   onDownloadExcel,
//   targetMargins,
// }) => {
//   const toCrores = (value) => {
//     return (value / 10000000).toFixed(2);
//   };

//   const calculateRowTotal = (row, categories) => {
//     let totalSales = 0;
//     let totalWeightedMargin = 0;

//     categories.forEach(category => {
//       const sales = row[`${category}_Sales`] || 0;
//       const margin = row[`${category}_Margin`] || 0;
//       totalSales += sales;
//       totalWeightedMargin += sales * (margin / 100);
//     });

//     const avgMargin = totalSales > 0
//       ? Number(((totalWeightedMargin / totalSales) * 100).toFixed(2))
//       : 0;

//     return {
//       totalSales,
//       avgMargin
//     };
//   };

//   const getTargetMargin = (category) =>
//     targetMargins[category] || targetMargins['Other'] || 20;

//   const OVERALL_TARGET_MARGIN = 20;

//   return (
//     <div className={styles.wrapper}>
//       <div className={styles.header}>
//         <h3 className={styles.title}>Quarterly Performance Analysis</h3>
//         <button onClick={onDownloadExcel} className={styles.excelButton}>
//           <span className={styles.excelIcon}>📥</span>
//           Download Excel
//         </button>
//       </div>

//       <div className={styles.tableContainer}>
//         <table className={styles.table}>
//           <colgroup>
//             <col style={{ width: '70px' }} />
//             <col style={{ width: '80px' }} />
//             <col style={{ width: '130px' }} />
//             <col style={{ width: '130px' }} />
//             <col style={{ width: '130px' }} />
//             <col style={{ width: '130px' }} />
//             {categories.map((cat, idx) => (
//               <React.Fragment key={`colgroup-${cat}-${idx}`}>
//                 <col style={{ width: '130px' }} />
//                 <col style={{ width: '130px' }} />
//                 <col style={{ width: '130px' }} />
//                 <col style={{ width: '130px' }} />
//               </React.Fragment>
//             ))}
//           </colgroup>

//           <thead>
//             <tr className={styles.headerRow1}>
//               <th rowSpan="2" className={styles.thSticky}>Year</th>
//               <th rowSpan="2" className={styles.thSticky2}>Month</th>
//               <th colSpan="4" className={styles.thTotal}>Total</th>
//               {categories.map((category) => (
//                 <th key={category} colSpan="4" className={styles.thCategory}>
//                   {category}
//                 </th>
//               ))}
//             </tr>
//             <tr className={styles.headerRow2}>
//               {/* Total column sub-headers */}
//               <th className={styles.thSub}>Achieved %</th>
//               <th className={styles.thSub}>Target (Cr)</th>
//               <th className={styles.thSub}>Sales (Cr)</th>
//               <th className={styles.thSub}>GM %</th>
//               {/* Category sub-headers */}
//               {categories.map((category) => (
//                 <React.Fragment key={`${category}-headers`}>
//                   <th className={styles.thSub}>Achieved %</th>
//                   <th className={styles.thSub}>Target (Cr)</th>
//                   <th className={styles.thSub}>Sales (Cr)</th>
//                   <th className={styles.thSub}>GM ({getTargetMargin(category)}%)</th>
//                 </React.Fragment>
//               ))}
//             </tr>
//           </thead>

//           <tbody>
//             {data.map((row, index) => {
//               const totals = calculateRowTotal(row, categories);

//               return (
//                 <tr key={`${row.Year}-${row.Month}-${index}`} 
//                     className={`${styles.dataRow} ${row.isQuarter ? styles.quarterRow : ''}`}>
//                   <td className={styles.tdSticky}>{row.Year}</td>
//                   <td className={`${styles.tdSticky2} ${row.isQuarter ? styles.quarterText : ''}`}>
//                     {row.Month}
//                   </td>

//                   {/* TOTAL columns */}
//                   <td className={`${styles.tdRight} ${styles.totalCol}`}>-</td>
//                   <td className={`${styles.tdRight} ${styles.totalCol}`}>-</td>
//                   <td className={`${styles.tdRight} ${styles.totalCol}`}>
//                     ₹{toCrores(totals.totalSales)} Cr
//                   </td>
//                   <td className={`${styles.tdRight} ${styles.totalCol} ${styles.borderRight}`}>
//                     <span className={totals.avgMargin >= OVERALL_TARGET_MARGIN ? styles.gmGreen : styles.gmRed}>
//                       {totals.avgMargin}%
//                     </span>
//                   </td>

//                   {/* Category columns */}
//                   {categories.map((cat, idx) => {
//                     const sales = row[`${cat}_Sales`] || 0;
//                     const margin = row[`${cat}_Margin`] || 0;
//                     const salesCr = toCrores(sales);
//                     const targetGM = getTargetMargin(cat);

//                     return (
//                       <React.Fragment key={`${cat}-${idx}`}>
//                         <td className={styles.tdRight}>-</td>
//                         <td className={styles.tdRight}>-</td>
//                         <td className={styles.tdRight}>₹{salesCr} Cr</td>
//                         <td className={`${styles.tdRight} ${idx === categories.length - 1 ? '' : styles.borderRight}`}>
//                           <span className={margin >= targetGM ? styles.gmGreen : styles.gmRed}>
//                             {margin}%
//                           </span>
//                         </td>
//                       </React.Fragment>
//                     );
//                   })}
//                 </tr>
//               );
//             })}

//             {/* Grand Total Row - Simplified */}
//             <tr className={styles.totalRow}>
//               <td className={styles.tdStickyTotal}>Total</td>
//               <td className={styles.tdStickyTotal2}>-</td>
//               <td className={styles.tdTotal}>-</td>
//               <td className={styles.tdTotal}>-</td>
//               <td className={styles.tdTotal}>
//                 ₹{toCrores(data.reduce((sum, row) => {
//                   let total = 0;
//                   categories.forEach(cat => total += row[`${cat}_Sales`] || 0);
//                   return sum + total;
//                 }, 0))} Cr
//               </td>
//               <td className={`${styles.tdTotal} ${styles.borderRight}`}>
//                 {(() => {
//                   let totalSales = 0;
//                   let totalWeighted = 0;
//                   data.forEach(row => {
//                     categories.forEach(cat => {
//                       const sales = row[`${cat}_Sales`] || 0;
//                       const margin = row[`${cat}_Margin`] || 0;
//                       totalSales += sales;
//                       totalWeighted += sales * (margin / 100);
//                     });
//                   });
//                   const avgMargin = totalSales > 0 ? (totalWeighted / totalSales) * 100 : 0;
//                   return (
//                     <span className={avgMargin >= OVERALL_TARGET_MARGIN ? styles.gmGreen : styles.gmRed}>
//                       {avgMargin.toFixed(2)}%
//                     </span>
//                   );
//                 })()}
//               </td>

//               {/* Category totals */}
//               {categories.map((cat, idx) => {
//                 const totalSales = data.reduce((sum, row) => sum + (row[`${cat}_Sales`] || 0), 0);
//                 let totalWeighted = 0;
//                 data.forEach(row => {
//                   const sales = row[`${cat}_Sales`] || 0;
//                   const margin = row[`${cat}_Margin`] || 0;
//                   totalWeighted += sales * (margin / 100);
//                 });
//                 const avgMargin = totalSales > 0 ? (totalWeighted / totalSales) * 100 : 0;
//                 const targetGM = getTargetMargin(cat);

//                 return (
//                   <React.Fragment key={`total-${cat}-${idx}`}>
//                     <td className={styles.tdTotal}>-</td>
//                     <td className={styles.tdTotal}>-</td>
//                     <td className={styles.tdTotal}>₹{toCrores(totalSales)} Cr</td>
//                     <td className={`${styles.tdTotal} ${idx === categories.length - 1 ? '' : styles.borderRight}`}>
//                       <span className={avgMargin >= targetGM ? styles.gmGreenTotal : styles.gmRedTotal}>
//                         {avgMargin.toFixed(2)}%
//                       </span>
//                     </td>
//                   </React.Fragment>
//                 );
//               })}
//             </tr>
//           </tbody>
//         </table>
//       </div>
//     </div>
//   );
// };

// export default QuarterlyTable;

import React from 'react';
import styles from './QuarterlyTable.module.css';

// ─── Hardcoded monthly targets for FY 2025-26 (Crores) ──────────────────────
const TARGET_SALES_CR_FY_2025_26 = {
  '2025-04': { '3A Chemicals': 0.2,  BIKAI: 0,    CATO: 0.05, 'FD Cell': 0,    KANTO: 0,    Capricorn: 0.02, VOLAB: 0, Density: 0.3, Deutero: 1,   Trading: 1,  'Life Science': 0, Other: 0 },
  '2025-05': { '3A Chemicals': 0.2,  BIKAI: 0,    CATO: 0.05, 'FD Cell': 0,    KANTO: 0.04, Capricorn: 0.02, VOLAB: 0, Density: 0.3, Deutero: 1,   Trading: 1,  'Life Science': 0, Other: 0 },
  '2025-06': { '3A Chemicals': 0.3,  BIKAI: 0,    CATO: 0.05, 'FD Cell': 0,    KANTO: 0.04, Capricorn: 0.02, VOLAB: 0, Density: 0.3, Deutero: 1,   Trading: 1,  'Life Science': 0, Other: 0 },
  '2025-07': { '3A Chemicals': 0.3,  BIKAI: 0.2,  CATO: 0.05, 'FD Cell': 0.02, KANTO: 0.04, Capricorn: 0.02, VOLAB: 0, Density: 0.3, Deutero: 1,   Trading: 1,  'Life Science': 0, Other: 0 },
  '2025-08': { '3A Chemicals': 0.5,  BIKAI: 0.2,  CATO: 0.05, 'FD Cell': 0.02, KANTO: 0.04, Capricorn: 0.02, VOLAB: 0, Density: 0.3, Deutero: 1,   Trading: 1,  'Life Science': 0, Other: 0 },
  '2025-09': { '3A Chemicals': 0.5,  BIKAI: 0.2,  CATO: 0.1,  'FD Cell': 0.02, KANTO: 0.04, Capricorn: 0.02, VOLAB: 0, Density: 0.3, Deutero: 1,   Trading: 2,  'Life Science': 0, Other: 0 },
  '2025-10': { '3A Chemicals': 0.5,  BIKAI: 0.4,  CATO: 0.2,  'FD Cell': 0.1,  KANTO: 0.1,  Capricorn: 0.04, VOLAB: 0, Density: 0.5, Deutero: 1,   Trading: 2,  'Life Science': 0, Other: 0 },
  '2025-11': { '3A Chemicals': 0.7,  BIKAI: 0.5,  CATO: 0.5,  'FD Cell': 0.2,  KANTO: 0.1,  Capricorn: 0.1,  VOLAB: 0, Density: 0.5, Deutero: 1,   Trading: 2,  'Life Science': 0, Other: 0 },
  '2025-12': { '3A Chemicals': 0.8,  BIKAI: 0.8,  CATO: 0.5,  'FD Cell': 0.5,  KANTO: 0.1,  Capricorn: 0.1,  VOLAB: 0, Density: 1,   Deutero: 2,   Trading: 2,  'Life Science': 0, Other: 0 },
  '2026-01': { '3A Chemicals': 1.2,  BIKAI: 0.8,  CATO: 0.8,  'FD Cell': 0.6,  KANTO: 0.3,  Capricorn: 0.1,  VOLAB: 0, Density: 1,   Deutero: 2,   Trading: 2,  'Life Science': 0, Other: 0 },
  '2026-02': { '3A Chemicals': 1.5,  BIKAI: 1,    CATO: 0.8,  'FD Cell': 1,    KANTO: 0.3,  Capricorn: 0.2,  VOLAB: 0, Density: 1,   Deutero: 2.5, Trading: 2,  'Life Science': 0, Other: 0 },
  '2026-03': { '3A Chemicals': 2.0,  BIKAI: 1.2,  CATO: 1,    'FD Cell': 1,    KANTO: 0.3,  Capricorn: 0.2,  VOLAB: 0, Density: 1,   Deutero: 2.5, Trading: 3,  'Life Science': 0, Other: 0 },
};

const QUARTER_MAP = { Q1: [4,5,6], Q2: [7,8,9], Q3: [10,11,12], Q4: [1,2,3] };

const QuarterlyTable = ({ data, categories, onDownloadExcel, targetMargins }) => {
  const toCrores = (v) => ((v || 0) / 10000000).toFixed(2);

  const toMonthKey = (row) =>
    `${row.Year}-${String(row.MonthNumber).padStart(2, '0')}`;

  // All monthly (non-quarter) rows
  const monthlyRows = data.filter((r) => !r.isQuarter && r.MonthNumber);

  const calculateRowTotal = (row) => {
    let totalSales = 0, totalWeighted = 0;
    categories.forEach((cat) => {
      const sales  = row[`${cat}_Sales`]  || 0;
      const margin = row[`${cat}_Margin`] || 0;
      totalSales   += sales;
      totalWeighted += sales * (margin / 100);
    });
    return {
      totalSales,
      avgMargin: totalSales > 0
        ? Number(((totalWeighted / totalSales) * 100).toFixed(2)) : 0,
    };
  };

  // Get the fiscal-start year for a given row
  const getFiscalYear = (row) => {
    const y = parseInt(row.Year, 10);
    return String(row.Month || '').toUpperCase() === 'Q4' ? y - 1 : y;
  };

  // Keys for months belonging to this quarter row
  const getQuarterMonthKeys = (qLabel, row) => {
    const monthNums = new Set(QUARTER_MAP[qLabel] || []);
    const fy        = getFiscalYear(row);
    return monthlyRows
      .filter((r) => {
        const mn = Number(r.MonthNumber);
        if (!monthNums.has(mn)) return false;
        return qLabel === 'Q4' && [1,2,3].includes(mn)
          ? r.Year === fy + 1
          : r.Year === fy;
      })
      .map(toMonthKey);
  };

  // Target helpers
  const getMonthTarget = (mKey, cat) =>
    TARGET_SALES_CR_FY_2025_26?.[mKey]?.[cat] ?? 0;

  const getRowTargetCr = (row) => {
    if (row.isQuarter) {
      const keys = getQuarterMonthKeys(String(row.Month).toUpperCase(), row);
      return keys.reduce((acc, k) =>
        acc + categories.reduce((s, c) => s + getMonthTarget(k, c), 0), 0);
    }
    if (row.MonthNumber) {
      const mKey = toMonthKey(row);
      return categories.reduce((s, c) => s + getMonthTarget(mKey, c), 0);
    }
    return null;
  };

  const getCategoryTargetCr = (row, cat) => {
    if (row.isQuarter) {
      const keys = getQuarterMonthKeys(String(row.Month).toUpperCase(), row);
      return keys.reduce((s, k) => s + getMonthTarget(k, cat), 0);
    }
    if (row.MonthNumber) return getMonthTarget(toMonthKey(row), cat);
    return 0;
  };

  // Grand totals (monthly rows only)
  const grandTotals = (() => {
    const totals = {
      totalSales: 0, totalTarget: 0, totalWeighted: 0,
      catSales: {}, catTarget: {}, catWeighted: {}, catSalesAcc: {},
    };
    categories.forEach((c) => {
      totals.catSales[c] = 0; totals.catTarget[c] = 0;
      totals.catWeighted[c] = 0; totals.catSalesAcc[c] = 0;
    });
    monthlyRows.forEach((row) => {
      const mKey = toMonthKey(row);
      categories.forEach((cat) => {
        const sales  = row[`${cat}_Sales`]  || 0;
        const margin = row[`${cat}_Margin`] || 0;
        const target = getMonthTarget(mKey, cat);
        totals.totalSales        += sales;
        totals.totalWeighted     += sales * (margin / 100);
        totals.totalTarget       += target;
        totals.catSales[cat]     += sales;
        totals.catWeighted[cat]  += sales * (margin / 100);
        totals.catSalesAcc[cat]  += sales;
        totals.catTarget[cat]    += target;
      });
    });
    totals.grandMargin = totals.totalSales > 0
      ? Number(((totals.totalWeighted / totals.totalSales) * 100).toFixed(2)) : 0;
    categories.forEach((cat) => {
      totals.catMargin = totals.catMargin || {};
      totals.catMargin[cat] = totals.catSalesAcc[cat] > 0
        ? Number(((totals.catWeighted[cat] / totals.catSalesAcc[cat]) * 100).toFixed(2)) : 0;
    });
    return totals;
  })();

  const getTargetMargin  = (cat) => targetMargins[cat] || targetMargins['Other'] || 20;
  const OVERALL_TGT_MARGIN = 20;

  const baseCell = styles.tdRight;

  const renderCategoryCells = (row, cat, idx) => {
    const sales    = row[`${cat}_Sales`]  || 0;
    const margin   = row[`${cat}_Margin`] || 0;
    const salesCr  = Number(toCrores(sales));
    const targetCr = getCategoryTargetCr(row, cat);
    const achieved = targetCr > 0 ? Number(((salesCr / targetCr) * 100).toFixed(2)) : null;
    const tgm      = getTargetMargin(cat);
    const isAlt    = idx % 2 === 0;
    const bg       = row.isQuarter ? '#86efac' : isAlt ? '#f0fdf4' : 'transparent';
    const borderL  = idx === 0 ? '1px solid #e5e7eb' : '2px solid #d1d5db';

    return (
      <React.Fragment key={cat}>
        <td className={baseCell} style={{ backgroundColor: bg, borderLeft: borderL, color: row.isQuarter ? '#065f46' : '#374151' }}>
          {achieved != null ? `${achieved}%` : '-'}
        </td>
        <td className={baseCell} style={{ backgroundColor: bg }}>
          ₹{Number(targetCr).toFixed(2)} Cr
        </td>
        <td className={baseCell} style={{ backgroundColor: bg }}>
          ₹{salesCr} Cr
        </td>
        <td className={baseCell} style={{ backgroundColor: bg, color: margin >= tgm ? '#15803d' : '#dc2626', fontWeight: 700 }}>
          {margin}%
        </td>
      </React.Fragment>
    );
  };

  const renderGrandTotalCategoryCells = (cat) => {
    const salesCr  = Number(toCrores(grandTotals.catSales[cat] || 0));
    const targetCr = grandTotals.catTarget[cat] || 0;
    const margin   = grandTotals.catMargin?.[cat] || 0;
    const achieved = targetCr > 0 ? Number(((salesCr / targetCr) * 100).toFixed(2)) : null;
    const tgm      = getTargetMargin(cat);

    return (
      <React.Fragment key={cat}>
        <td className={styles.tdTotal}>{achieved != null ? `${achieved}%` : '-'}</td>
        <td className={styles.tdTotal}>₹{Number(targetCr).toFixed(2)} Cr</td>
        <td className={styles.tdTotal}>₹{salesCr} Cr</td>
        <td className={styles.tdTotal} style={{ color: margin >= tgm ? '#86efac' : '#fca5a5' }}>
          {margin}%
        </td>
      </React.Fragment>
    );
  };

  const totalSalesCr  = Number(toCrores(grandTotals.totalSales));
  const totalTargetCr = Number(grandTotals.totalTarget);
  const totalAchieved = totalTargetCr > 0
    ? Number(((totalSalesCr / totalTargetCr) * 100).toFixed(2)) : null;

  return (
    <div className={styles.wrapper}>
      <div className={styles.header}>
        <h3 className={styles.title}>Quarterly Performance Analysis</h3>
        <button onClick={onDownloadExcel} className={styles.excelButton}>
          <span className={styles.excelIcon}>📥</span> Download Excel
        </button>
      </div>

      <div className={styles.tableContainer}>
        <table className={styles.table}>
          <colgroup>
            <col style={{ width: '70px' }} />
            <col style={{ width: '80px' }} />
            {/* Total: 4 cols */}
            <col style={{ width: '130px' }} /><col style={{ width: '130px' }} />
            <col style={{ width: '130px' }} /><col style={{ width: '130px' }} />
            {categories.map((_, i) => (
              <React.Fragment key={i}>
                <col style={{ width: '130px' }} /><col style={{ width: '130px' }} />
                <col style={{ width: '130px' }} /><col style={{ width: '130px' }} />
              </React.Fragment>
            ))}
          </colgroup>

          <thead>
            <tr className={styles.headerRow1}>
              <th rowSpan="2" className={styles.thSticky}>Year</th>
              <th rowSpan="2" className={styles.thSticky2}>Month</th>
              <th colSpan="4" className={styles.thTotal}>Total</th>
              {categories.map((cat) => (
                <th key={cat} colSpan="4" className={styles.thCategory}>{cat}</th>
              ))}
            </tr>
            <tr className={styles.headerRow2}>
              <th className={styles.thSub}>Achieved %</th>
              <th className={styles.thSub}>Target (Cr)</th>
              <th className={styles.thSub}>Sales (Cr)</th>
              <th className={styles.thSub}>GM %</th>
              {categories.map((cat) => (
                <React.Fragment key={`${cat}-sub`}>
                  <th className={styles.thSub}>Achieved %</th>
                  <th className={styles.thSub}>Target (Cr)</th>
                  <th className={styles.thSub}>Sales (Cr)</th>
                  <th className={styles.thSub}>GM ({getTargetMargin(cat)}%)</th>
                </React.Fragment>
              ))}
            </tr>
          </thead>

          <tbody>
            {data.map((row, index) => {
              const totals      = calculateRowTotal(row);
              const rowTargetCr = getRowTargetCr(row);
              const totalSCr    = Number(toCrores(totals.totalSales));
              const rowAchieved = rowTargetCr && rowTargetCr > 0
                ? Number(((totalSCr / rowTargetCr) * 100).toFixed(2)) : null;

              return (
                <tr key={`${row.Year}-${row.Month}-${index}`}
                    className={`${styles.dataRow} ${row.isQuarter ? styles.quarterRow : ''}`}>
                  <td className={styles.tdSticky}>{row.Year}</td>
                  <td className={`${styles.tdSticky2} ${row.isQuarter ? styles.quarterText : ''}`}>
                    {row.Month}
                  </td>

                  {/* TOTAL columns */}
                  <td className={`${styles.tdRight} ${styles.totalCol}`}>
                    {rowAchieved != null ? `${rowAchieved}%` : '-'}
                  </td>
                  <td className={`${styles.tdRight} ${styles.totalCol}`}>
                    {rowTargetCr != null ? `₹${Number(rowTargetCr).toFixed(2)} Cr` : '-'}
                  </td>
                  <td className={`${styles.tdRight} ${styles.totalCol}`}>
                    ₹{totalSCr} Cr
                  </td>
                  <td className={`${styles.tdRight} ${styles.totalCol} ${styles.borderRight}`}>
                    <span className={totals.avgMargin >= OVERALL_TGT_MARGIN ? styles.gmGreen : styles.gmRed}>
                      {totals.avgMargin}%
                    </span>
                  </td>

                  {/* Category columns */}
                  {categories.map((cat, idx) => renderCategoryCells(row, cat, idx))}
                </tr>
              );
            })}

            {/* Grand total row */}
            <tr className={styles.totalRow}>
              <td className={styles.tdStickyTotal}>Total</td>
              <td className={styles.tdStickyTotal2}>-</td>
              <td className={styles.tdTotal}>
                {totalAchieved != null ? `${totalAchieved}%` : '-'}
              </td>
              <td className={styles.tdTotal}>₹{totalTargetCr.toFixed(2)} Cr</td>
              <td className={styles.tdTotal}>₹{totalSalesCr} Cr</td>
              <td className={`${styles.tdTotal} ${styles.borderRight}`}>
                <span className={grandTotals.grandMargin >= OVERALL_TGT_MARGIN ? styles.gmGreenTotal : styles.gmRedTotal}>
                  {grandTotals.grandMargin}%
                </span>
              </td>
              {categories.map(renderGrandTotalCategoryCells)}
            </tr>
          </tbody>
        </table>
      </div>
    </div>
  );
};

export default QuarterlyTable;